import React from 'react'
import { logEvent } from 'firebase/analytics'
import { MedicalViewsList, MedicalViewLink } from './styles'
import { FeatureFlag } from '../../FeatureFlag'
import { DEFAULT_PATH, SelectMedicalViewsOptions } from '~/constants'
import { medicalViewRoutesPath } from '~/constants/route/pathsOfMedicalViews'
import { usePatient } from '~/context'
import { EMedicalViews, MedicalViewsType } from '~/interfaces'
import { analytics } from '~/firebase-analytics'

interface ListOptionProps {
  option: MedicalViewsType
  selectedOption: MedicalViewsType
  onClick: (option: MedicalViewsType) => void
}

const ListOption = ({ option, selectedOption, onClick }: ListOptionProps): JSX.Element => {
  const { patient } = usePatient()

  return (
    <li>
      <MedicalViewLink
        to={`/${DEFAULT_PATH}/${medicalViewRoutesPath[option]}/${patient?.medicalRecord}`}
        selected={option === selectedOption}
        onClick={() => onClick(option)}
      >
        {SelectMedicalViewsOptions[option]}
      </MedicalViewLink>
    </li>
  )
}

export interface PopoverTypeVisualizationProps {
  selectedOption: MedicalViewsType
  hasPregnancies?: boolean
}

export const PopoverTypeVisualization = ({
  selectedOption,
  hasPregnancies = true
}: PopoverTypeVisualizationProps): JSX.Element => {
  let visualizationOptions = Object.values(EMedicalViews).filter(medicalView => medicalView !== EMedicalViews.NONE)

  if (!hasPregnancies) {
    visualizationOptions = visualizationOptions.filter(medicalView => medicalView !== EMedicalViews.MATERNAL_INFANT)
  }

  const registerEvent = (option: MedicalViewsType) => {
    logEvent(analytics, 'medical_view_navigation', { content_type: option })
  }

  return (
    <MedicalViewsList>
      {visualizationOptions.map((option: MedicalViewsType, index) => {
        if (option === EMedicalViews.ONCOLOGY) {
          return (
            <FeatureFlag key={index} flag="OncologyView">
              <ListOption option={option} selectedOption={selectedOption} onClick={registerEvent} />
            </FeatureFlag>
          )
        }
        return <ListOption key={index} option={option} selectedOption={selectedOption} onClick={registerEvent} />
      })}
    </MedicalViewsList>
  )
}
